import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// Map for responsive rules.
// -----------------------------------------------------------------------------
export const DEFAULT_HEADER_EDITORIAL_BAR = 'none';
export const DEFAULT_HEADER_EDITORIAL = false;
export const EDITORIAL_RULES = {
    h1: {
        color: tokens.colors.mint[900].value,
        height: 12,
        width: 96
    },
    h2: {
        color: tokens.colors.cyan[700].value,
        height: 12,
        width: 64
    },
    h3: {
        color: tokens.colors.indigo[500].value,
        height: 8,
        width: 48
    },
    h4: {
        color: tokens.colors.mint[900].value,
        height: 4,
        width: 48
    }
};
export const SIZES_RULES = {
    '10xl': {
        fontSize: tokens.font.size['10xl'].value,
        fontWeight: tokens.font.weight.black.value,
        marginBottom: getSpace('6xl')
    },
    '9xl': {
        fontSize: tokens.font.size['9xl'].value,
        fontWeight: tokens.font.weight.black.value,
        marginBottom: getSpace('5xl')
    },
    '8xl': {
        fontSize: tokens.font.size['8xl'].value,
        fontWeight: tokens.font.weight.black.value,
        marginBottom: getSpace('4xl')
    },
    '7xl': {
        fontSize: tokens.font.size['7xl'].value,
        fontWeight: tokens.font.weight.black.value,
        marginBottom: getSpace('3xl')
    },
    '6xl': {
        fontSize: tokens.font.size['6xl'].value,
        fontWeight: tokens.font.weight.black.value,
        marginBottom: getSpace('2xl')
    },
    '5xl': {
        fontSize: tokens.font.size['5xl'].value,
        fontWeight: tokens.font.weight.bold.value,
        marginBottom: getSpace('2xl')
    },
    '4xl': {
        fontSize: tokens.font.size['4xl'].value,
        fontWeight: tokens.font.weight.bold.value,
        marginBottom: getSpace('2xl')
    },
    '3xl': {
        fontSize: tokens.font.size['3xl'].value,
        fontWeight: tokens.font.weight.bold.value,
        marginBottom: getSpace('l')
    },
    '2xl': {
        fontSize: tokens.font.size['2xl'].value,
        fontWeight: tokens.font.weight.bold.value,
        marginBottom: getSpace('l')
    },
    xl: {
        fontSize: tokens.font.size['xl'].value,
        fontWeight: tokens.font.weight.bold.value,
        marginBottom: getSpace('m')
    },
    l: {
        fontSize: tokens.font.size['l'].value,
        fontWeight: tokens.font.weight.bold.value,
        marginBottom: getSpace('m')
    },
    m: {
        fontSize: tokens.font.size['m'].value,
        fontWeight: tokens.font.weight.bold.value,
        marginBottom: getSpace('s')
    },
    s: {
        fontSize: tokens.font.size['s'].value,
        fontWeight: tokens.font.weight.extraBold.value,
        marginBottom: getSpace('s')
    },
    xs: {
        fontSize: tokens.font.size['xs'].value,
        fontWeight: tokens.font.weight.extraBold.value,
        marginBottom: getSpace('s')
    },
    '2xs': {
        fontSize: tokens.font.size['2xs'].value,
        fontWeight: tokens.font.weight.extraBold.value,
        marginBottom: getSpace('xs')
    }
};
export const AS_RULES = {
    h1: '5xl',
    h2: '4xl',
    h3: '3xl',
    h4: '2xl',
    h5: 'xl',
    h6: 'l'
};
//# sourceMappingURL=Header.constants.js.map